import * as React from 'react'
import { generateFilterId } from './createIcon'
import { IconOptions } from './icon-options'

function IconContent({
  color = 'currentColor',
  backgroundColor = '#fff',
  filterId = generateFilterId()
}: IconOptions & React.HTMLAttributes<HTMLOrSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='53' fill='none'>
      <g fillRule='evenodd' clipRule='evenodd' filter={`url(#${filterId})`}>
        <path
          fill={backgroundColor}
          d='M12.3137 34.9413 23.6274 46.255l11.3137-11.3137v-.0001c2.8955-2.8954 4.6863-6.8954 4.6863-11.3137 0-8.8366-7.1634-16-16-16-8.8365 0-16 7.1634-16 16 0 4.4183 1.791 8.4183 4.6864 11.3137l-.0001.0001Z'
        />
        <path fill={color} d='m24 15.255-6 6v8h4v-5c0-1.1046.8954-2 2-2s2 .8954 2 2v5h4v-8l-6-6Z' />
      </g>
      <defs>
        <filter
          id={filterId}
          width='40'
          height='46.6276'
          x='3.6274'
          y='5.6274'
          colorInterpolationFilters='sRGB'
          filterUnits='userSpaceOnUse'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            result='hardAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          />
          <feOffset dy='2' />
          <feGaussianBlur stdDeviation='2' />
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0' />
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow' />
          <feBlend in='SourceGraphic' in2='effect1_dropShadow' result='shape' />
        </filter>
      </defs>
    </svg>
  )
}

export const MapPinIcon = IconContent
